import React from 'react'
import { Checkbox } from 'baseui/checkbox'

interface CustomCheckboxProps {
    checked: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    children: React.ReactNode
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange, children }) => {
    return (
        <Checkbox
            checked={checked}
            onChange={onChange}
            overrides={{
                Root: {
                    style: {
                        width: '200px',
                        height: '60px',
                        display: 'flex',
                        alignItems: 'center'
                    }
                },
                ToggleTrack: {
                    style: {
                        width: '10px',
                        height: '10px'
                    }
                },
                Toggle: {
                    style: {
                        width: '10px',
                        height: '10px'
                    }
                },
                Label: {
                    style: {
                        marginTop: '3px'
                    }
                }
            }}
        >
            {children}
        </Checkbox>
    )
}
